import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineLicenseRequestDto extends EpimsBaseEntityDto {


    EstimatedDuration: number;

    PipelineId: string;
  
    StartDate: Date;
    
    EndDate: Date;
 
    Status: string;
  
    Remarks: string;

    NoOfYears: number;

    PipelineLicenseCategoryId: string;
    CategoryName: string;

    nextExpirationDate: string;
     nextRenewalDate: string;
     ProgressPercent: number;

     TemplateId: string;
     StartDateActual: Date;
     EndDateActual: Date;
     BatchId: string;


}